(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-art-landing"]) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('.eal-jumps a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  history.replaceState(history.state, '', link.hash);
  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-cosmic-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var link = event.target.closest('.ech__path[href^="#"], .epo__route[href^="#"]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  var target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  var header = document.querySelector('[data-section-type="header"]');
  var clearance = header ? Math.max(0, header.getBoundingClientRect().bottom) + 20 : (window.innerWidth < 1000 ? 130 : 210);
  window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - clearance), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-project-pathway"] && !Shopify.designMode) return;
  try {
    
function eliteOpenPath() {
  const id = window.location.hash.slice(1);
  if (!id) return;
  const target = document.getElementById(id);
  if (target && target.matches('.egp-route') && target.tagName === 'DETAILS') {
    target.open = true;
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'auto' }));
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', eliteOpenPath);
else eliteOpenPath();
window.addEventListener('hashchange', eliteOpenPath);
document.addEventListener('click', (event) => {
  const link = event.target.closest('.egp a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target || !target.matches('.egp-route')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  history.replaceState(null, '', link.hash);
  eliteOpenPath();
}, true);
document.addEventListener('shopify:section:load', eliteOpenPath);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elite-shopping-paths"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.elite-brand-hero a[href="#shop-products"]');
  const target = document.getElementById('shop-products');
  if (!link || !target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  history.replaceState(null, '', '#shop-products');
  target.scrollIntoView({ block: 'start', behavior: 'auto' });
}, true);

  } catch(e) { console.error(e); }
})();
})();
